import moment from 'moment';
import type { CoreTypes } from '../../../core';
import { getStartYear } from './util';


export function extractDivisionName (input: string): undefined | Pick<CoreTypes.Serialized.Division, 'displayName'> {
  // extract base and offset year
  const displayName = input.match(/^School=(.+)$/m)
    ?.at(1)
    ?.trim();

  return displayName ? { displayName } : undefined;
}

export function extractStartAndEnd (input: string): undefined | Pick<CoreTypes.Serialized.Division, 'start' | 'end'> {

  // extract the PeriodGeneral table content
  const match = input.match(/PeriodGeneral \((?:\d+)\)(?:\r\n|\r|\n)\[Rows\](?:\r\n|\r|\n)SchoolYear \((?:\d+)\)(?:\r\n|\r|\n)([^\n]*)/);
  if (!match) return;

  // date rangers on the form "20/8-23/8, 26/8-30/8, ..., 9/6-13/6"
  const dateRanges = match.at(1)?.trim();
  if (!dateRanges) return;

  // extract the first date of the first range and the last date of the last range
  const _start = dateRanges.match(/(\d{1,2}\/\d{1,2})/) ?.at(1);
  const _end   = dateRanges.match(/(\d{1,2}\/\d{1,2})$/)?.at(1);
  if (!_start || !_end) return;

  // format the dates to YYYY-MM-DD using moment
  const startYear = getStartYear(input);
  if (!startYear) return;
  const start = moment.utc(`${_start}/${startYear}`, 'DD/MM/YYYY').startOf('day');
  const end   = moment.utc(`${_end}/${startYear}`, 'DD/MM/YYYY')  .endOf  ('day');
  if (!start.isValid() || !end.isValid()) return;

  // if the start date is after the end date, increase the year of the end date
  while (start.isAfter(end)) end.add(1, 'year');

  return { start, end };
}

export const division = (input: unknown): Partial<Pick<CoreTypes.Serialized.Division, 'displayName' | 'start' | 'end'>> => {
  const division: Partial<Pick<CoreTypes.Serialized.Division, 'displayName' | 'start' | 'end'>> = {};
  if (typeof input !== 'string') return division;

  // division name
  {
    const x = extractDivisionName(input);
    if (x) Object.assign(division, x);
  }

  // division range
  {
    const x = extractStartAndEnd(input);
    if (x) Object.assign(division, x);
  }

  return division;
};